// src/components/PortalRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePortalAuth } from '../context/PortalAuthContext';

export default function PortalRoute({ children }) {
  const { session, loading } = usePortalAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f8f9fa',
        fontFamily: 'Georgia, serif',
        color: '#666',
        fontSize: '15px',
        letterSpacing: '0.02em'
      }}>
        Loading…
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/portal/login" replace />;
  }

  return children;
}
